// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__7h8hW","tips_message":"styles_tips_message__3EbAN","modal":"styles_modal__2tU7j"};